<template>
  <div>
    <div style="width: 100%;height:350px" :id="id"></div>
  </div>
</template>
<script>
// 按需引入 ECharts 图表和组件
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入饼状图
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
// 引入legend模块
require("echarts/lib/component/legend");

export default {
  components: {},
  props: {},
  data() {
    return {
      id: 'id' + Math.floor(Math.random() * 1000),
      chart: null
    }
  },

  created() {},
  mounted() {
    this.init()
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    init() {
      // 基于准备好的dom，初始化echarts实例
      this.chart = echarts.init(document.getElementById(this.id))
      window.onresize = () => {
        this.chart.resize()
      }
    },
    setData(data, total) {
      this.pie(data, total)
    },
    pie: function(data, total) {
      let legendData = []
      data.forEach(item => {
        legendData.push(item.name)
      })
      let option = {
        title: {
          text: ``,
          // subtext: `共${total}辆`,
          textAlign: 'center',
          // textVerticalAlign: 'bottom',
          // bottom: 0,
          left: '50%'
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b}: {c}"
          // "{b}: {c} ({d}%)"
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 10,
          left: 'center',
          data: legendData
          // ['西凉', '益州', '兖州', '荆州', '幽州']
        },
        series: [{
          name: '标准化进度',
          type: 'pie',
          color: ['#5396ff', '#62c564', '#f2cf31', '#3f4780', '#8a54e4', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'],
          radius: '65%',
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              position: 'left',
              formatter: "{b}: {c}"
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '14',
                fontWeight: 'bold'
              }
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: data,
          bottom: 50,
        }],
      };
      this.chart.setOption(option)
    },
  }
}

</script>
